module.exports = __webpack_public_path__ + "img/section_icon.a734480f.svg";